<template>
	<div>
		<div
			v-if="candidateInfoState.profileName"
			class="mt-2 ml-2 mb-1 rec-title-2 d-flex align-items-center"
		>
			<img src="../../../../assets/newdesign/dashboard/svg-resume.svg" alt="" />
			{{ candidateInfoState.profileName }}
		</div>
		<div class="candash-bold-black-txt-2 pt-2 ml-2 position-relative">
			Preview Video Snapshot
			<div class="hor-line"></div>
		</div>
		<div
			class="d-flex align-items-center justify-content-center h93 w-100 mt-3 mb-3 mob-height-unset"
		>
			<div class="d-flex flex-column justify-content-center vr-blue-preview">
				<div class="vr-white-name">My Video Snap</div>
				<div class="sp-black-preview position-relative video-container">
					<div v-if="!videoProcessed" class="cvs-black-screen">
						<div class="white-bar-loader">
							<div v-for="i in 8" :key="i"></div>
						</div>
						<div class="text-white-1">Video Processing...</div>
						<div class="text-white-2">Please come back in some time</div>
					</div>
					<video
						v-if="videoResume"
						:src="videoResume"
						:autoplay="false"
						:muted="false"
						:loop="false"
						disablePictureInPicture
						disableRemotePlayback
						x-webkit-airplay="deny"
						x5-playsinline
						webkit-playsinline
						playsinline
						width="100%"
						height="100%"
						style="object-fit: unset; height: 100%; border-radius: 5px"
						ref="camera"
						id="videoElement"
						@click="togglePlayPause"
						@loadedmetadata="onVideoLoaded"
						@timeupdate="updateProgress"
						@ended="onVideoEnded"
					/>
					<!-- Custom Controls -->
					<div class="custom-controls" v-if="videoLoaded">
						<div
							class="controls-bottom justify-content-between align-items-center"
						>
							<div class="d-flex align-items-center mb-2">
								<button class="control-btn play-btn" @click="togglePlayPause">
									<svg
										v-if="isPlaying"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="white"
									>
										<path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
									</svg>
									<svg
										v-else
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="white"
									>
										<path d="M8 5v14l11-7z" />
									</svg>
								</button>
								<div class="mb-1">
									<span class="time-display">{{ currentTimeFormatted }} /</span>
									<span class="time-display"> {{ durationFormatted }}</span>
								</div>
							</div>

							<button class="control-btn volume-btn" @click="toggleMute">
								<svg
									v-if="isMuted"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="white"
								>
									<path
										d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
									/>
								</svg>
								<svg
									v-else
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="white"
								>
									<path
										d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"
									/>
								</svg>
							</button>
						</div>
						<div class="time-progress-container">
							<div class="recorded-progress-bar" @click="seek">
								<div
									class="recorded-progress-filled"
									:style="{ width: progressPercent + '%' }"
								></div>
								<div
									class="recorded-progress-handle"
									:style="{ left: progressPercent + '%' }"
								></div>
							</div>
						</div>
					</div>
				</div>
				<div id="hideinmobile" class="d-flex justify-content-center mt-3 pb-2">
					<div class="position-relative">
						<b-button @click="goTosysCheck" class="candash-cancelBtn"
							><img
								class="mr-2"
								src="../../../../assets/newdesign/videoresume/retakeCam.svg"
								alt=""
							/>Retake</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<div id="hideinlaptop" class="d-flex justify-content-center mt-3 pb-2">
			<div class="position-relative">
				<b-button @click="goTosysCheck" class="candash-cancelBtn"
					><img
						class="mr-2"
						src="../../../../assets/newdesign/videoresume/retakeCam.svg"
						alt=""
					/>Retake</b-button
				>
			</div>
		</div>
	</div>
</template>
<script>
import { getCandidateDetail } from "../../../../controllers/dashboard/asynchronous.js";
import { mapGetters } from "vuex";
import HelpSection from "../../../../views/Dashboard/components/HelpSection.vue";
export default {
	name: "previewResume",
	components: {
		HelpSection,
	},
	data() {
		return {
			candidateInfo: {},
			videoResume: "",
			isPlaying: false,
			isMuted: false,
			currentTime: 0,
			duration: 0,
			videoLoaded: false,
			pollingInterval: null,
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfoState: "getcandidateInfo",
		}),
		progressPercent() {
			if (this.duration === 0) return 0;
			return (this.currentTime / this.duration) * 100;
		},
		currentTimeFormatted() {
			console.log(this.currentTime, "currentTime");
			return this.formatTime(this.currentTime);
		},
		durationFormatted() {
			console.log(this.duration, "duration");
			return this.formatTime(this.duration);
		},
		videoProcessed() {
			let src = this.videoResume;
			if (src && src.length > 0 && this.videoLoaded) {
				return true;
			}
			return false;
		},
	},
	mounted() {
		this.setupFullscreenListener();
	},
	beforeDestroy() {
		if (this.pollingInterval) {
			clearInterval(this.pollingInterval);
		}
	},
	async created() {
		this.initializeCandidateDetails();
		console.log(this.candidateInfoState, "vuex");
	},
	methods: {
		formatTime(seconds) {
			if (isNaN(seconds) || !isFinite(seconds)) return "0:00";
			const mins = Math.floor(seconds / 60);
			const secs = Math.floor(seconds % 60);
			return `${mins}:${secs.toString().padStart(2, "0")}`;
		},
		onVideoLoaded() {
			const video = this.$refs.camera;
			if (video) {
				this.duration = video.duration;
				this.videoLoaded = true;
			}
		},

		togglePlayPause() {
			const video = this.$refs.camera;
			if (video) {
				if (video.paused) {
					video.play();
					this.isPlaying = true;
				} else {
					video.pause();
					this.isPlaying = false;
				}
			}
		},
		toggleMute() {
			const video = this.$refs.camera;
			if (video) {
				video.muted = !video.muted;
				this.isMuted = video.muted;
			}
		},
		updateProgress() {
			const video = this.$refs.camera;
			if (video) {
				this.currentTime = video.currentTime;
			}
		},
		seek(event) {
			const video = this.$refs.camera;
			const progressBar = event.currentTarget;
			const rect = progressBar.getBoundingClientRect();
			const pos = (event.clientX - rect.left) / rect.width;
			if (video) {
				video.currentTime = pos * this.duration;
			}
		},
		onVideoEnded() {
			this.isPlaying = false;
		},
		toggleSettings() {
			// Settings menu can be implemented here if needed
			console.log("Settings clicked");
		},
		isSafari() {
			const userAgent = navigator.userAgent.toLowerCase();
			return (
				userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1
			);
		},
		setupFullscreenListener() {
			document.addEventListener("fullscreenchange", this.restrictDownload);
			document.addEventListener(
				"webkitfullscreenchange",
				this.restrictDownload
			);
			document.addEventListener("mozfullscreenchange", this.restrictDownload);
			document.addEventListener("MSFullscreenChange", this.restrictDownload);
		},
		restrictDownload(event) {
			const videoElement = document.getElementById("videoElement");

			if (
				document.fullscreenElement === videoElement ||
				document.webkitFullscreenElement === videoElement ||
				document.mozFullScreenElement === videoElement ||
				document.msFullscreenElement === videoElement
			) {
				document.addEventListener("contextmenu", this.disableRightClick);
			} else {
				document.removeEventListener("contextmenu", this.disableRightClick);
			}
		},
		disableRightClick(event) {
			event.preventDefault();
		},
		async initializeCandidateDetails() {
			await this.fetchCandidateDetails();

			if (
				!this.videoResume ||
				this.videoResume.length === 0 ||
				!this.videoLoaded
			) {
				if (this.pollingInterval) clearInterval(this.pollingInterval);
				this.pollingInterval = setInterval(async () => {
					await this.fetchCandidateDetails();
				}, 10000);
			}
		},
		async fetchCandidateDetails() {
			const res = await getCandidateDetail(this);
			if (res) {
				this.candidateInfo = res;
				this.videoResume = this.candidateInfo.videoResume;
			}

			await this.$nextTick();
			const video = this.$refs.camera;

			if (
				this.videoResume &&
				this.videoResume.length > 0 &&
				this.videoProcessed
			) {
				if (this.pollingInterval) {
					clearInterval(this.pollingInterval);
					this.pollingInterval = null;
				}
			}
		},
		goTosysCheck() {
			this.$store.commit("candidateVUEX/updatePreviewResume", true);
			this.$router.push({
				name: "systemcheck",
			});
		},
	},
};
</script>
<style scoped>
.video-container {
	position: relative;
	width: 100%;
}

video {
	display: block;
	width: 100%;
}
/* Hide all native controls */
video::-webkit-media-controls {
	display: none !important;
}

video::-webkit-media-controls-enclosure {
	display: none !important;
}

video::-webkit-media-controls-panel {
	display: none !important;
}

video::-webkit-media-controls-start-playback-button {
	display: none !important;
}

.cvs-black-screen {
	background-color: #000000;
	position: absolute;
	height: 100%;
	border-radius: 5px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 15px;
}
.cvs-black-screen .text-white-1 {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #ffffff;
}
.cvs-black-screen .text-white-2 {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #ffffff;
}

.white-bar-loader {
	position: relative;
	width: 40px;
	height: 40px;
}

.white-bar-loader div {
	transform-origin: 2px -8px;
	animation: spinFade 0.8s linear infinite;
	position: absolute;
	top: 30px;
	left: 18px;
	width: 5px;
	height: 11px;
	border-radius: 2px;
	background: #ffffff;
}

.white-bar-loader div:nth-child(1) {
	transform: rotate(0deg);
	animation-delay: -0.8s;
}
.white-bar-loader div:nth-child(2) {
	transform: rotate(45deg);
	animation-delay: -0.7s;
}
.white-bar-loader div:nth-child(3) {
	transform: rotate(90deg);
	animation-delay: -0.6s;
}
.white-bar-loader div:nth-child(4) {
	transform: rotate(135deg);
	animation-delay: -0.5s;
}
.white-bar-loader div:nth-child(5) {
	transform: rotate(180deg);
	animation-delay: -0.4s;
}
.white-bar-loader div:nth-child(6) {
	transform: rotate(225deg);
	animation-delay: -0.3s;
}
.white-bar-loader div:nth-child(7) {
	transform: rotate(270deg);
	animation-delay: -0.2s;
}
.white-bar-loader div:nth-child(8) {
	transform: rotate(315deg);
	animation-delay: -0.1s;
}

@keyframes spinFade {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0.2;
	}
}
</style>
